export default "__VITE_ASSET__DlmpudlK__ 480w, __VITE_ASSET__CqDGF5jf__ 800w, __VITE_ASSET__DfSXNYuF__ 1200w";